import { createContext, useMemo, useState } from 'react';
import React from 'react';
import { TJourneyConfig } from './types';

export interface PBApiProduct {
  insurerConfig: {
    nominalCodes: {
      liability: {
        description: string;
        creditOrDebit: string;
        code: string;
      };
      revenue: {
        description: string;
        creditOrDebit: string;
        code: string;
      };
    };
    ipt: {
      type: string;
      amount: number;
    };
    commissions: {
      other: any[];
      fixedBrokers: string[];
    };
    coolOffPeriod: {
      type: string;
      amount: number;
    };
    insurer: {
      name: string;
      frn: string;
      cancellationFee: number;
      id: string;
      mtaFee: number;
      productId: string;
      productName: string;
    };
  };
  productType: string;
  claimsHandler: string;
  insurerName: string;
  published: boolean;
  brokers: {
    [key: string]: {
      sendWelcomeEmail: boolean;
      brokerCollect: string;
      name: string;
      sendRenewalEmail: boolean;
      isStatementOfAccounts?: boolean;
      id: string;
      state: string;
      type: string;
      stripePK: string;
    };
  }[];
  flightdeckHosted: boolean;
  quoteEngine: string;
  cancellationFee: number;
  reIndexedAt: string;
  openSearchReIndexStamp: number;
  productSlug: string;
  avgAnnualGwp: number;
  category: string;
  images: any;
  commission: number;
  claimsHandlerEmail: string;
  description: string;
  id: string;
  coolingOffPeriodInDays: number;
  productName: string;
  type: string;
  journeyConfig: TJourneyConfig;
  state: string;
  documents: any[];
}


interface ProductsContextType {
  isStatementOfAccounts: boolean;
  product: PBApiProduct | null;
  updateProductData: (data: any) => void;
}

/*
 * MAIN Products Context
 * This context is used to store the product data that comes from PB API
 */
export const ProductsContext = createContext<ProductsContextType>({
  isStatementOfAccounts: false,
  product: null,
  updateProductData: () => {}
});

function ProductsContextProvider({ children }: any) {
  const [product, setProduct] = useState<PBApiProduct | null>(null);

  const updateProductData = (data: any) => setProduct(data);

  const brokerId = useMemo(() => {
    return product?.brokers && Object.keys(product.brokers[0] || {})[0];
  }, [product]);

  const contextValues = useMemo(() => ({
    isStatementOfAccounts:
      brokerId && product?.brokers?.[0][brokerId]
        ? product.brokers[0][brokerId].isStatementOfAccounts || false
        : false,
    product,
    updateProductData,
  }), [product, brokerId]);

  return <ProductsContext.Provider value={contextValues}>{children}</ProductsContext.Provider>;
}

export default ProductsContextProvider;
